var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getIsShowPopupSubmitReportSuccess
    ? _c(
        "div",
        {
          staticClass: "modal fade",
          class: [
            "modal fade",
            {
              show: _vm.getIsShowPopupSubmitReportSuccess,
              "d-block": _vm.getIsShowPopupSubmitReportSuccess,
            },
          ],
          staticStyle: { display: "block", "overflow-y": "scroll" },
          attrs: {
            id: "go-setting-report",
            "data-backdrop": "static",
            tabindex: "-1",
            "aria-hidden": "true",
          },
        },
        [
          _vm.language == "ko"
            ? _c(
                "div",
                {
                  staticClass: "modal-dialog go-modal-event",
                  staticStyle: { "max-width": "700px" },
                },
                [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-body" }, [
                      _c("div", { staticClass: "go-block-body" }, [
                        _c("div", { staticClass: "go-icon-wrap" }, [
                          _c(
                            "div",
                            {
                              staticClass: "go-animation go-success-animation",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "go-success-svg",
                                  attrs: { viewBox: "0 0 50 50" },
                                },
                                [
                                  _c("circle", {
                                    staticClass: "success-circle",
                                    attrs: {
                                      cx: "25",
                                      cy: "25",
                                      r: "24",
                                      fill: "none",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    staticClass: "success-check",
                                    attrs: {
                                      fill: "none",
                                      d: "M14.1 27.2l7.1 7.2 16.7-16.8",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "lead" }, [
                          _vm._v("리포트가 정상적으로 제출되었습니다."),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-default",
                          attrs: { type: "button", "data-dismiss": "modal" },
                          on: { click: _vm.handleCloseModal },
                        },
                        [_vm._v("확인")]
                      ),
                    ]),
                  ]),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "modal-dialog go-modal-event",
                  staticStyle: { "max-width": "700px" },
                },
                [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-body" }, [
                      _c("div", { staticClass: "go-block-body" }, [
                        _c("div", { staticClass: "go-icon-wrap" }, [
                          _c(
                            "div",
                            {
                              staticClass: "go-animation go-success-animation",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "go-success-svg",
                                  attrs: { viewBox: "0 0 50 50" },
                                },
                                [
                                  _c("circle", {
                                    staticClass: "success-circle",
                                    attrs: {
                                      cx: "25",
                                      cy: "25",
                                      r: "24",
                                      fill: "none",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    staticClass: "success-check",
                                    attrs: {
                                      fill: "none",
                                      d: "M14.1 27.2l7.1 7.2 16.7-16.8",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "lead" }, [
                          _vm._v("The report has been successfully submitted."),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-default",
                          attrs: { type: "button", "data-dismiss": "modal" },
                          on: { click: _vm.handleCloseModal },
                        },
                        [_vm._v("OK")]
                      ),
                    ]),
                  ]),
                ]
              ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }